import React from 'react';
import { createRoot } from 'react-dom/client';
import ReactDOM from 'react-dom';
import { StyleSheetManager } from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import App from './App';
import { RootContext, getRootStoreInstance } from './store/rootStore';
import apolloClient from './api/apolloClient';
import './assets/css/index.css';

const styledCompsInsertionPoint = document.getElementById('styled-components-insertion-point')!;
const rootEl = document.getElementById('root')!;
const root = createRoot(rootEl);

// This workaround is needed because react-jss was deprecated and completely breaks
// all stylings with React 18. This magically does not happen in production build, so we
// may safely leave it there. But while we use react-jss in the project, we need to have this
// hack in order to see how styles are applied in the real app.
if (process.env.NODE_ENV === 'production') {
  root.render(
    <StyleSheetManager target={styledCompsInsertionPoint}>
      <React.StrictMode>
        <RootContext.Provider value={getRootStoreInstance()}>
          <ApolloProvider client={apolloClient}>
            <App />
          </ApolloProvider>
        </RootContext.Provider>
      </React.StrictMode>
    </StyleSheetManager>,
  );
} else {
  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(
    <StyleSheetManager target={styledCompsInsertionPoint}>
      <React.StrictMode>
        <RootContext.Provider value={getRootStoreInstance()}>
          <ApolloProvider client={apolloClient}>
            <App />
          </ApolloProvider>
        </RootContext.Provider>
      </React.StrictMode>
    </StyleSheetManager>,
    rootEl,
  );
}
